module.exports = __webpack_public_path__ + "img/demo.256e8f6d.png";